import React from 'react'
import { Divider, Form, Image, Input, Typography } from 'antd'

import { isSafePromotionPosterUrl } from 'utils/storefrontPromotion'

const StorefrontDisplay = ({ detailsForm }) => {
  const posterUrl = Form.useWatch('poster_url', detailsForm)

  return (
    <section aria-label="Promotion page content">
      <Divider orientation="left">Promotion page content</Divider>
      <Typography.Paragraph type="secondary">
        Available products appear automatically on the shop during their promotion's active dates.
        Cards use each variant's PV and are ordered by the nearest promotion expiry.
        Add optional poster and content below for the promotion detail page. Existing promotion rules still apply.
      </Typography.Paragraph>

      <Form.Item
        label="Promotion poster URL"
        name="poster_url"
        extra="Optional. Paste a direct HTTP or HTTPS image URL for the promotion detail page."
        rules={[
          {
            validator(_, value) {
              const url = value?.trim()
              if (!url) return Promise.resolve()
              return isSafePromotionPosterUrl(url)
                ? Promise.resolve()
                : Promise.reject(new Error('Enter a valid HTTP or HTTPS image URL without login details.'))
            },
          },
          { max: 2048, message: 'The poster URL must be 2,048 characters or fewer.' },
        ]}
      >
        <Input size="large" placeholder="https://example.com/promotion-poster.jpg" />
      </Form.Item>

      {posterUrl && isSafePromotionPosterUrl(posterUrl.trim()) && (
        <div className="mb-4">
          <Image
            src={posterUrl.trim()}
            alt="Promotion poster preview"
            width={180}
            style={{ maxHeight: 240, objectFit: 'contain' }}
          />
        </div>
      )}

      <Form.Item
        label="Storefront description"
        name="storefront_description"
        extra="Optional plain text. Leave this, rules, and terms empty to show a centered poster-only detail page."
        rules={[{ max: 60000, message: 'Use 60,000 characters or fewer.' }]}
      >
        <Input.TextArea rows={4} maxLength={60000} placeholder="Introduce the promotion to shoppers" />
      </Form.Item>
      <Form.Item label="Promotion rules & mechanics" name="rules_mechanics" rules={[{ max: 60000, message: 'Use 60,000 characters or fewer.' }]}>
        <Input.TextArea rows={4} maxLength={60000} placeholder="Explain the qualifying purchases and how to claim the offer" />
      </Form.Item>
      <Form.Item label="Terms & conditions" name="terms_conditions" rules={[{ max: 60000, message: 'Use 60,000 characters or fewer.' }]}>
        <Input.TextArea rows={4} maxLength={60000} placeholder="Add any promotion terms and conditions" />
      </Form.Item>
    </section>
  )
}

export default StorefrontDisplay
